import env from '../../services/environment'
import 'paho-mqtt'

var Paho = window.Paho

const mqtt = function (store) {
  store.subscribe(mutation => {
    if (mutation.type === 'GET_MYPROFILE_SUCCESS') {
      if (!store.getters.isMqttConnected) startConnectionInterval()
    } else if (mutation.type === 'SELECT_SITE') {
      if (store.getters.mqttCurrentSiteId) removeSiteEventSubscription(store.getters.mqttCurrentSiteId)
      addSiteEventSubscription(store.getters.currentSiteId)
    }
  })

  let client = null
  let connectInterval$ = null
  let connectionRetrySecond = 5

  function startConnectionInterval () {
    if (!store.getters.isMqttConnected) {
      connect('app', store.getters.myMqttAccessToken, 'enduser-web-' + Math.floor(Math.random() * 1000000000))
    }
    stopConnectionInterval()
    connectInterval$ = setInterval(() => {
      if (!store.getters.isMqttConnected) {
        connect('app', store.getters.myMqttAccessToken, 'enduser-web-' + Math.floor(Math.random() * 1000000000))
      }
    }, connectionRetrySecond * 1000)
  }

  function stopConnectionInterval () {
    if (connectInterval$) {
      clearInterval(connectInterval$)
      connectInterval$ = null
    }
  }

  function connect (userName, password, clientId) {
    client = new Paho.MQTT.Client(env.mqttTargetPath, env.mqttTargetPathPort, '', clientId)
    client.onConnectionLost = function (responseObject) {
      if (responseObject.errorCode !== 0) {
        store.commit('MQTT_DISCONNECTED')
      }
    }
    client.onMessageArrived = function (message) {
      let destination = message.destinationName
      let payloadString = message.payloadString
      let payloadBytes = message.payloadBytes
      parseMessage(destination, payloadString, payloadBytes)
    }
    client.onFailure = function (err) {
      console.log(err)
    }
    client.connect({
      useSSL: true,
      userName: userName,
      password: password,
      onSuccess: function () {
        store.commit('MQTT_CONNECTED')
        if (store.getters.currentSiteId) addSiteEventSubscription(store.getters.currentSiteId)
      }
    })
  }

  function addSiteEventSubscription (siteId) {
    if (store.getters.isMqttConnected) {
      client.subscribe('chekt/sites/' + siteId, {qos: 1})
      setTimeout(() => { store.commit('MQTT_SITE_SUBSCRIBE', siteId) }, 1000)
    }
  }

  function removeSiteEventSubscription (siteId) {
    if (store.getters.isMqttConnected) {
      client.unsubscribe('chekt/sites/' + siteId, {})
      store.commit('MQTT_SITE_UNSUBSCRIBE', siteId)
    }
  }

  function onNewEvent (deviceId, eventId) {
    // get event for only cameras (not non-camera device)
    if (store.getters.camera(deviceId)) {
      store.dispatch('getSiteCameraEvent', {
        cameraId: deviceId,
        eventId: eventId
      })
    }
  }

  function onPrivacyChange (deviceId, isEnabled) {
    console.log('deviceId: ' + deviceId)
    console.log('isEnabled: ' + isEnabled)
  }

  function parseMessage (destination, payloadString, payloadBytes) {
    let body
    try {
      body = JSON.parse(payloadString)
    } catch (e) {
      console.log(e)
    }

    let destinationObj = destination.split('/')
    if (destinationObj[0] === 'chekt') {
      if (destinationObj[1] === 'sites') {
        if (body) {
          if (body['type']) {
            if (body['type'] === 'notification') {
              if (body['subject'] === 'event') {
                if (body['payload']) {
                  if (body['payload']['event_id'] && body['payload']['device_id']) {
                    onNewEvent(body['payload']['device_id'], body['payload']['event_id'])
                    // console.log(body)
                  } else {
                    console.log('Wrong mqtt message payload!')
                    console.log(body)
                  }
                } else {
                  console.log('Mqtt message payload not found!')
                  console.log(body)
                }
              } else if (body['subject'] === 'privacy') {
                if (body['payload']) {
                  if (body['payload']['device_id'] && body['payload']['enable'] !== null && body['payload']['enable'] !== undefined) {
                    onPrivacyChange(body['payload']['device_id'], body['payload']['enable'])
                    // console.log(body)
                  } else {
                    console.log('Wrong mqtt message payload!')
                    console.log(body)
                  }
                } else {
                  console.log('Mqtt message payload not found!')
                  console.log(body)
                }
              } else {
                console.log('Not supported mqtt message subject!')
                console.log(body)
              }
            } else {
              console.log('Not supported mqtt message type!')
              console.log(body)
            }
          } else {
            console.log('Wrong mqtt body!')
            console.log(body)
          }
        } else {
          console.log('Wrong mqtt payload!')
          console.log(payloadString)
        }
      } else {
        console.log('Not supported mqtt destination!')
        console.log(destination)
      }
    } else {
      console.log('Not supported mqtt destination!')
      console.log(destination)
    }
  }
}

export default mqtt



// WEBPACK FOOTER //
// ./src/store/plugins/mqtt.js